import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 25 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.15 12.75H5.9v-1.5h6.25V5h1.5v6.25h6.25v1.5h-6.25V19h-1.5z" })
});
export default SvgPlus;
